import RegistrationComplete from './RegistrationComplete';

export default RegistrationComplete;
